import { Model, belongsTo, hasMany } from 'miragejs';
import attr from 'ember-data/attr';

export default Model.extend({
  location: belongsTo('graphql/location'),
  visitor: belongsTo('graphql/visitor'),
  userData: hasMany('graphql/user-data'),

  additionalGuests: attr('int'),
  isDelivery: attr('boolean'),
  flowName: attr('string'),

  signedInAt: attr('date'),
});
